<script setup>
import SettingsLayout from "@/Layouts/Settings.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Select from "@/Components/Select.vue";
import Heading from "@/Components/Settings/Heading.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { onUnmounted } from "vue";

function getNumbers(start, stop, step = 1) {
    return new Array(stop / step).fill(start).map((n, i) => (i + 1) * step);
}
const zeroPad = (num, places) => String(num).padStart(places, "0");
let saveBtnClicked = false;

function submitForm() {
    saveBtnClicked = true;
    form.put("/einstellungen/einheit");
}

let props = defineProps({
    interval: Number,
    hasAppointments: Boolean,
    hasTypes: Boolean,
});

const canEdit = Inertia.page.props.auth.can["edit settings"];

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

const form = useForm({
    interval: props.interval,
});
</script>

<template>
    <Head title="Einheiten der Arbeitszeit - Grundeinstellungen" />
    <SettingsLayout>
        <template #breadcrumb>Einheiten der Arbeitszeit</template>
        <template #controls>
            <HeaderLink href="/" type="close" class="mr-3"
                >Schließen</HeaderLink
            >
            <HeaderButton
                v-if="canEdit && !props.hasAppointments && !props.hasTypes"
                @click="submitForm()"
                >Speichern</HeaderButton
            >
        </template>

        <Heading
            title=" Bitte stellen Sie den Minuten-Takt ein, im dem Sie Ihre
    Termine vergeben möchten."
        />

        <p class="max-w-2xl text-sm text-oteoText mt-8">
            Bitte stellen Sie den Zeit-Intervall ein, indem Sie Ihre Termine
            vergeben möchten. Diese Zeiteinheit wird in die Dauer Ihrer
            Behandlungstypen übernommen z.B. Kontrolltermin 15 Minuten. Bitte
            beachten Sie, dass Sie die Zeiteinheiten nicht mehr ändern können
            sobald Sie den ersten Termin vergeben haben.
        </p>

        <div class="max-w-sm">
            <div class="mt-8">
                <Label
                    for="interval"
                    value="Zeit-Intervall für den Terminplaner"
                />

                <Select
                    v-model="form.interval"
                    class="mt-1 w-80"
                    :disabled="
                        !canEdit || props.hasAppointments || props.hasTypes
                    "
                >
                    <option disabled value="">Bitte wählen</option>
                    <option
                        v-for="n in getNumbers(5, 60, 5)"
                        :key="n"
                        :value="n"
                    >
                        00:{{ zeroPad(n, 2) }} Minuten
                    </option>
                </Select>
            </div>
        </div>

        <p
            class="max-w-2xl text-sm text-oteoText mt-8"
            v-if="props.hasAppointments"
        >
            Es gibt bereits Termine in Ihrem Kalender. Bitte löschen Sie diese,
            bevor Sie das Zeit-Intervall ändern können.
        </p>

        <p class="max-w-2xl text-sm text-oteoText mt-8" v-if="props.hasTypes">
            Es wurden bereits Behandlungstypen angelegt. Bitte löschen Sie
            diese, bevor Sie das Zeit-Intervall ändern können.
        </p>
    </SettingsLayout>
</template>
